import React, { useState, useEffect, useCallback } from 'react';
import { getAnalysisProgress } from '../../services/analyses';
import './AnalysisProgress.css';

const AnalysisProgress = ({ analysisHash, onComplete }) => {
  const [progress, setProgress] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchProgress = useCallback(async () => {
    try {
      const data = await getAnalysisProgress(analysisHash);
      setProgress(data);

      if (data.status === 'completed' || data.status === 'failed') {
        onComplete?.(data.status);
      }
    } catch (err) {
      console.error('Error fetching progress:', err);
    } finally {
      setLoading(false);
    }
  }, [analysisHash, onComplete]);

  useEffect(() => {
    fetchProgress();
    const interval = setInterval(fetchProgress, 2000);
    return () => clearInterval(interval);
  }, [fetchProgress]);

  if (loading && !progress) {
    return <div className="progress-loading">Cargando...</div>;
  }

  const message = progress?.progress_message || 'Iniciando análisis...';
  const percent = progress?.summary?.percent_complete || 0;

  return (
    <div className="analysis-progress">
      <div className="progress-message">{message}</div>
      <div className="progress-bar-container">
        <div className="progress-bar-fill" style={{ width: `${percent}%` }} />
      </div>
      <div className="progress-percent">{percent}%</div>
    </div>
  );
};

export default AnalysisProgress;
